import { LanguageOptions } from "@/Administration/Models/UI/Enums/Administration";
import { ClickableTextItem } from "@/Common/Api/ClickableText/Dto/ClickableTextItem";
import { BaseReactComponent } from "@/Common/Components/BaseReactComponent";
import { MyleHelper } from "@/Common/Helpers/MyleHelper";
import { EmployeeUIModel } from "@/Common/Models/UI/Employee/EmployeeUIModel";

interface IBaseObstetricalFileClickableTextProps {
    user: EmployeeUIModel;
    languageOption: LanguageOptions;
    readonly?: boolean;

    onEditClickableText?: (item: ClickableTextItem) => void;
    onAddNewClicakbleText?: (context: string) => void;
    onImport?: (context: string) => void;
    onDelete?: (context: string, label: string) => void;
}

abstract class BaseObstetricalFileClickableText<TProps extends IBaseObstetricalFileClickableTextProps> extends BaseReactComponent<TProps> {
    protected renderSection(header: string, body: JSX.Element): JSX.Element {
        return (
            <div>
                <div className="sub-header"><h4>{header}</h4></div>
                <div className="psingle-column practice centered">
                    <div className="tb">
                        <div className="tbc">
                            <div>
                                <table>
                                    {body}
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    protected renderClickableTextRow(label: string, popupContext: string): JSX.Element {
        const language = sessionStore.getLanguageStringFromEnum(this.props.languageOption);

        return this.props.readonly
            ? this.renderClickableTextReadonlyRow(label, popupContext, language)
            : this.renderClickableTextEditRow(label, popupContext, language);
    }

    private renderClickableTextReadonlyRow(label: string, popupContext: string, language: string): JSX.Element {
        let clickableTextValues = this.props.user.getAggregatedTabNames(popupContext, language) ?? [];
        return (
            <tr>
                <td className="c1" style={{ "paddingTop": "5px", "verticalAlign": "top" }}><label className="form-label">{label}</label></td>
                <td className="c2" style={{ "paddingTop": "5px", "verticalAlign": "top" }}><strong>{MyleHelper.ReplaceEmptyString(clickableTextValues.map((r: { TabName: string; }) => r.TabName).join(", "))}</strong></td>
            </tr>
        );
    }

    private renderClickableTextEditRow(label: string, popupContext: string, language: string): JSX.Element {
        let clickableTextValues = this.props.user.getAggregatedTabNames(popupContext, language) ?? [];
        return (
            <tr>
                <td className="c1" style={{ paddingTop: "5px", verticalAlign: "top", width: "265px" }}>
                    <label className="form-label" style={{ "paddingRight": "3px" }}>{label}</label>
                    <a onClick={() => this.props.onAddNewClicakbleText?.(popupContext)}>
                        <strong>[+]</strong>
                    </a>
                </td>
                <td className="c2" style={{ "paddingTop": "5px", "verticalAlign": "top" }}>
                    <strong>
                        {clickableTextValues != null && clickableTextValues.length > 0 && clickableTextValues.map((x: ClickableTextItem, i: number) => (
                            <a key={i + `_${popupContext}`} onClick={() => this.props.onEditClickableText?.(x)}>
                                {x.TabName} {(i != clickableTextValues.length - 1) && " , "}
                            </a>
                        ))}
                        {clickableTextValues != null && clickableTextValues.length == 0 && "--"}
                    </strong>
                </td>
                <td style={{ textAlign: "right", width: "100px" }}>
                    <a onClick={() => this.props.onImport?.(popupContext)} style={{ marginRight: "5px", textDecoration: "underline" }}>
                        <strong>{cacheStore.GetString("ImportLabel")}</strong>
                    </a>
                    |
                    <a onClick={() => this.props.onDelete?.(popupContext, label)} style={{ marginLeft: "5px", textDecoration: "underline", color: "red" }}>
                        <strong>{cacheStore.GetString("DeleteLabel")}</strong>
                    </a>
                </td>
            </tr>
        );
    }
}

export { BaseObstetricalFileClickableText, IBaseObstetricalFileClickableTextProps };
